import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'inches'
})
export class InchesPipe implements PipeTransform {
    public transform(value: any): string {
        let feet = 0;
        let inches = 0;

        if (null != value) {
            let numericValue = +value;

            feet = Math.floor(numericValue / 12);
            inches = inches % 12;
        }

        return `${feet}' ${inches}"`;
    }
}
